import { store } from 'app/store';
import { setToast } from './ToastifySlice';

export function openToastify(severity: string, message: string, errorType?: string) {
  store.dispatch(setToast({ severity, message, errorType }));
}
